/**
 * Persist API tokens across page loads. This is mainly to facilitate
 * negotiation between login and the rest of the ide, since they are
 * separate apps and we must stuff the token somewhere other than
 * memory in order to retrieve it.
 *
 * For the time being, this is just a thin wrapper around localStorage.
 * Usage should be:
 *
 *    Login app:
 *        Perform successful auth
 *        use setToken(token)
 *    Ide app on login:
 *        look for token in localstorage
 *        set api in memory
 *        use clearToken on logout
 */
import moment from 'moment';

    var SLUG = 'ei_v5_access_token';
    var TIMESLUG = 'ei_v5_access_token_expiry';
    var REFRESH_SLUG = 'ei_v5_refresh_token';
    var V4_API_TOKEN = 'ei_v4api_token';
    var V4_API_EXPIRE = 'ei_v4api_token_expiry';

    function getTokenExpiry() {
        var expiry = localStorage.getItem(TIMESLUG);
        if (expiry) {
            expiry = moment(expiry);
            return expiry && expiry.toDate();
        }
    }
    function setTokenExpiry(datestring) {
        return localStorage.setItem(TIMESLUG, datestring);
    }
    function getToken() {
        return localStorage.getItem(SLUG);
    }
    function setToken(new_token) {
        return localStorage.setItem(SLUG, new_token);
    }
    function setTokenRefresh(token) {
        return localStorage.setItem(REFRESH_SLUG, token);
    }
    function getTokenRefresh() {
        return localStorage.getItem(REFRESH_SLUG);
    }
    function clearToken() {
        localStorage.removeItem(V4_API_TOKEN);
        localStorage.removeItem(V4_API_EXPIRE);
        localStorage.removeItem(TIMESLUG);
        localStorage.removeItem(REFRESH_SLUG);
        return localStorage.removeItem(SLUG);
    }
    export default {
        getToken: getToken,
        setToken: setToken,
        clearToken: clearToken,
        setTokenExpiry: setTokenExpiry,
        getTokenExpiry: getTokenExpiry,
        setTokenRefresh: setTokenRefresh,
        getTokenRefresh: getTokenRefresh
    };

